import { createFileRoute } from '@tanstack/react-router';
import { taskRouteSchema } from '../../../../Utils/routeSchema';

export const Route = createFileRoute('/(main)/_layout/cases/_cases/$caseId/tasks/$taskId')({
  params: {
    parse: (params) => taskRouteSchema.parse(params),
  },
  component: RouteComponent,
});

function RouteComponent() {
  return null;
}
